module.exports = __webpack_public_path__ + "static/img/exploit14.51f23f61.png";